module.exports = __webpack_public_path__ + "images/176_640.jpg";